'use strict';

(function () {
    angular
        .module('app', [
            'app.config',
            'app.chat',
            'app.addFood',
            'app.foods',
            'app.leaderboard',
            'app.supplementList',
            'app.pinCode',
            'app.entityStats',
            'app.salesDashboard',
            'app.salesDeposits',
            'app.salesIncomeTransactions',
            'app.termsAndConditions',
            'app.membersAdded',
            'app.revenueReport',
            'app.superDashboard',
            'app.recommendedSteps',
            'app.coachEdit',
            'app.coachProfile',
            'app.customersDashboard',
            'app.customerProfile',
            'app.scoreTable',
            'app.entityProfile',
            'app.customerSetup',
            'app.preApprovalSetup',
            'app.preCheckIn',
            'app.preCheckInProceed',
            'app.supplementSetup',
            'app.supplementProfile',
            'app.certificates',
            'app.nutrition',
            'app.addSalesRep',
            'app.addRecipe',
            'app.childEntityList',
            'app.active-calendar',
            'app.foodScore',
            'app.reports',
            'app.guidesAndAdditionalInfo',
            'app.signInAuth0',
            'app.scholastic',
            'app.entityManagement',
            'app.customerManagement',
            'app.authManagement',
            'app.inbody',
            'app.payment',
            'app.coachManagement',
            'app.scanIqCustomerManagement',
            'app.home',
            'app.notes',
            'app.challenges',
            'app.foodManagement',
            'app.releases',
        ]);
})();
